import React, { useState } from "react";
import { Users, ChevronRight, Shield, Database, MapPin } from "lucide-react";
import { D, JAKARTA } from "./ui";
import { MayorPanel } from "./MayorPanel";
import { DataPanel } from "./DataPanel";
import { KotaNamaPanel } from "./KotaNamaPanel";

// Daftar bagian Pengaturan — tambahkan entri baru di sini agar nav atas tetap ramping
const SECTIONS = [
  { key: "walikota", label: "Walikota", desc: "Akun & kota binaan", icon: Users, Comp: MayorPanel },
  { key: "kota", label: "Nama Kota", desc: "Nama tampilan tiap kota", icon: MapPin, Comp: KotaNamaPanel },
  { key: "data", label: "Data & Migrasi", desc: "Tarik dari preview, cadangan", icon: Database, Comp: DataPanel },
];

// Halaman Pengaturan: menu samping kiri + isi bagian di kanan
export function SettingsPage({ token }) {
  const [sec, setSec] = useState(SECTIONS[0].key);
  const active = SECTIONS.find(s => s.key === sec) || SECTIONS[0];
  const Comp = active.Comp;

  return (
    <div data-testid="settings-page" style={{ padding: "22px 20px 30px", fontFamily: JAKARTA }}>
      <h2 style={{ margin: "0 0 18px", fontSize: 27, fontWeight: 800, letterSpacing: -0.6, color: D.ink }}>Pengaturan</h2>
      <div style={{ display: "flex", gap: 18, alignItems: "flex-start" }}>
        <aside data-testid="settings-menu" style={{ width: 250, flex: "none", background: "#fff", borderRadius: 26, padding: 12, boxShadow: "0 8px 22px rgba(20,20,20,0.05)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 10px 14px", borderBottom: `1px solid ${D.line}`, marginBottom: 10 }}>
            <span style={{ width: 40, height: 40, borderRadius: 14, background: D.dark, color: "#fff", display: "grid", placeItems: "center", fontWeight: 800, fontSize: 15, flex: "none" }}>A</span>
            <div style={{ minWidth: 0 }}>
              <b style={{ display: "block", fontSize: 13.5, color: D.ink }}>Admin Jawsel</b>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 11, color: D.sub, fontWeight: 700 }}><Shield size={11} /> Super Admin</span>
            </div>
          </div>
          <p style={{ margin: "0 10px 8px", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", color: D.sub }}>Sistem</p>
          {SECTIONS.map(({ key, label, desc, icon: Icon }) => {
            const on = key === sec;
            return (
              <button key={key} data-testid={`settings-sec-${key}`} onClick={() => setSec(key)}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "11px 12px", borderRadius: 16, border: 0, textAlign: "left", cursor: "pointer",
                  background: on ? D.dark : "transparent", color: on ? "#fff" : D.ink, fontFamily: JAKARTA, transition: "background-color .15s",
                }}
                onMouseEnter={e => { if (!on) e.currentTarget.style.background = D.cream; }}
                onMouseLeave={e => { if (!on) e.currentTarget.style.background = "transparent"; }}>
                <span style={{ width: 34, height: 34, borderRadius: 11, background: on ? "rgba(255,255,255,0.12)" : D.blueSoft, display: "grid", placeItems: "center", flex: "none" }}>
                  <Icon size={15} color={on ? "#9f9fff" : D.blue} />
                </span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <b style={{ display: "block", fontSize: 13.5 }}>{label}</b>
                  <span style={{ fontSize: 11.5, opacity: on ? 0.7 : 1, color: on ? "#fff" : D.sub }}>{desc}</span>
                </span>
                <ChevronRight size={14} style={{ opacity: on ? 1 : 0.35 }} />
              </button>
            );
          })}
        </aside>
        <main data-testid="settings-content" style={{ flex: 1, minWidth: 0 }}>
          <Comp token={token} />
        </main>
      </div>
    </div>
  );
}
